// extracted by mini-css-extract-plugin
export default {"btn_smscode":"edit-pwd_btn_smscode__1F6Tp","disable":"edit-pwd_disable__b6zD3","btn_login":"edit-pwd_btn_login__FtSUZ","row":"edit-pwd_row__Kr+j0","space":"edit-pwd_space__bCH79"};